import { BqApiProvider } from './../../providers/bq-api/bq-api';
import { Component } from '@angular/core';
import { NavController, ViewController } from 'ionic-angular';
import { ToastController } from "ionic-angular";

import { WelcomePage } from './../welcome/welcome';
import { AlertController } from 'ionic-angular';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  public stores: any;
  public profiles: any;
  public sending: boolean;
  public currentData: any;
  public categories: any;

  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    private bqApi: BqApiProvider
  ) {
    this.sending = false;
  }

  ionViewDidLoad() {
    this.stores = this.bqApi.get().stores;
    this.profiles = this.bqApi.get().profiles;
    this.categories = this.bqApi.get().categories;

    if( this.bqApi.getEverestData()){
      this.currentData = this.bqApi.getEverestData();
    }else{
      this.currentData = {
        date: null,
        name: null,
        profile: null,
        store: null,
        category: null,
        visitTime:  null
      }
    }
  }

  nextStep() {
    this.sending = true;
    if( !this.currentData.name || !this.currentData.date || !this.currentData.profile || !this.currentData.store ){
       let alert = this.alertCtrl.create({
         title: 'Faltan datos',
         subTitle:
           'Rellene todos los datos antes de continuar',
         buttons: ['OK']
       });

       alert.present();
       this.sending = false;
       return;
    }

    this.bqApi.setEverestData( this.currentData ).then(() => {
      this.viewCtrl.dismiss();
      this.navCtrl.push(WelcomePage);
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts